import { Reply } from './replies_api'

/**
 * Pick the reply that should carry a thread's interested / not-interested
 * verdict: the latest inbound message in the thread.
 *
 * The thread list's representative row is the thread's newest message, which
 * is one of our own `sent` rows whenever we replied last. Classifying that
 * row pushes the verdict (locally and to the sending vendor) onto the wrong
 * email (FIR-7589), so outbound rows are skipped here.
 *
 * @param threadReplies - All replies in the thread, sorted ascending by
 *   date_received (the order CampaignRepliesTab already maintains).
 * @param selected - The thread's representative row; returned as a fallback
 *   while the thread detail is still loading or when the thread has no
 *   inbound messages.
 * @returns The reply to classify, or undefined when nothing is selected.
 */
export function pickClassificationReply(
  threadReplies: Reply[],
  selected: Reply | undefined
): Reply | undefined {
  for (let i = threadReplies.length - 1; i >= 0; i--) {
    if (threadReplies[i].folder !== 'sent') {
      return threadReplies[i]
    }
  }
  return selected
}
